import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="copyRight">
          © 2024 ·
          <a
            style={{ color: "#000" }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://mufinpay.com/terms-and-conditions/"
          >
            Terms of use
          </a>
          <a
            style={{ color: "#000" }}
            target="_blank"
            rel="noopener noreferrer"
            href="https://mufinpay.com/privacy-policy/"
          >
            · Privacy policy
          </a>
        </div>
      </footer>
    );
  }
}

export default Footer;
